'use client'

import { useState } from 'react'

import cn from 'clsx'

import { Swiper, SwiperSlide } from 'swiper/react'
import { A11y } from 'swiper/modules'

import 'swiper/css'

import { Copy } from 'shared-components'

import Slide from './Slide'

import type { VideoGallery as VideoGalleryType } from '../../../../../apps/benmax/src/types/sanity.types'

import s from './VideoGallery.module.sass'

function VideoGallery({ title, copy, gallery }: VideoGalleryType) {
    const [activeIndex, setActiveIndex] = useState(0)

    return (
        <section className={s.VideoGallery}>
            <div className={cn(s.Cont, 'container')}>
                <div className={s.Intro}>
                    {title && <h2 dangerouslySetInnerHTML={{ __html: title }} />}
                    {copy && <Copy copy={copy} />}
                </div>
                <Swiper
                    modules={[A11y]}
                    spaceBetween={10}
                    slidesPerView={1.3}
                    className={s.Slider}
                    centeredSlides={true}
                    allowTouchMove={true}
                    // loop={true}
                    // slideToClickedSlide={true}
                    breakpoints={{
                        768: {
                            slidesPerView: 3,
                            spaceBetween: 30,
                            centeredSlides: false,
                        },
                    }}
                    onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
                >
                    {gallery?.map((item: any, index: number) => (
                        <SwiperSlide key={index}>
                            <Slide item={item} index={index} activeIndex={activeIndex} setActiveIndex={setActiveIndex} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </section>
    )
}

export default VideoGallery
